<template>
    <div class="form-group">
        <label class="form-label small mb-1">
            <localized-text localizedKey="Usa spunte" text="Usa spunte"></localized-text>
        </label>
        <div>
            <toggler v-model="localValue.useChecks"></toggler>
        </div>
    </div>
    <div class="form-group">
        <label class="form-label small mb-1">
            <localized-text localizedKey="Contenuto" text="Contenuto"></localized-text>
        </label>
        <list-filler v-model="localValue.points"></list-filler>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import { Options } from 'vue-class-component';
import { Mixins, Watch } from 'vue-property-decorator';
import WithModel from '@/mixins/withModel';

@Options({})
export default class bulletPointsBlock extends Mixins(WithModel) {
    declare localValue: OM.BulletPointsBlock;

    created(){
        if(!this.localValue.points){
            this.localValue.points = [];
        }
    }

    @Watch('localValue.isFullWidth')
    @Watch('localValue.marginBottom')
    @Watch('localValue.points', { deep: true })
    @Watch('localValue.useChecks')
    onTextChange(){
        this.localValue.htmlText = `<div class="bulletPointsBlock ${(!this.localValue.isFullWidth ? 'px-4' : '')} ${('mb-' + this.localValue.marginBottom)}">`;
            if(this.localValue.useChecks){
                this.localValue.points.forEach(x => {
                    this.localValue.htmlText += `
                    <div class="d-flex align-items-center mt-1">
                        <span class="fs-22 me-2">&#x2714;</span>
                        <span>${x}</span>
                    </div>
                    `;
                });
            } else {
                this.localValue.htmlText += `<ul>`;
                    this.localValue.points.forEach(x => {
                        this.localValue.htmlText += `
                        <li>${x}</li>
                        `;
                    });
                this.localValue.htmlText += `</ul>`;
            }
        this.localValue.htmlText += `</div>`;
    }

}
</script>
